var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.opacity)?_c('input-with-unit',{attrs:{"alternative-units":['%'],"size":"normal"},on:{"updated":_vm.set},model:{value:(_vm.opacity),callback:function ($$v) {_vm.opacity=$$v},expression:"opacity"}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }